import { render, staticRenderFns } from "./Partitions.vue?vue&type=template&id=6581907b&"
import script from "./Partitions.vue?vue&type=script&lang=js&"
export * from "./Partitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports